export default "__VITE_ASSET__hnQu8Lcy__"